import React, { useState, useEffect } from 'react';
import { Wheel } from 'react-custom-roulette';
import { useGameContext } from '../contexts/GameContext';
import kinksData from '../kinks.json';

const WheelMode = () => {
  const { availableKinks, selectedKink, setSelectedKink, selectRandomTaskByKink } = useGameContext();

  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);

  // Handle wheel spin
  const handleSpinClick = () => {
    if (!mustSpin) {
      const newPrizeNumber = Math.floor(Math.random() * availableKinks.length);
      setPrizeNumber(newPrizeNumber);
      setMustSpin(true);
      setSelectedKink(availableKinks[newPrizeNumber]);
    }
  };

  // Handle spin result
  useEffect(() => {
    if (!mustSpin && selectedKink) {
      selectRandomTaskByKink(selectedKink);
      setSelectedKink(null);
    }
  }, [mustSpin, selectedKink, selectRandomTaskByKink, setSelectedKink]);

  // Prepare the wheel data
  const wheelData = availableKinks.map((kink) => ({
    option: kink,
    style: { backgroundColor: kinksData[kink]?.color || '#ff8f43' }
  }));

  return (
    <div className="wheel-container">
      <h3>Spin the Wheel to Get a Kink</h3>
      {wheelData.length > 0 && (
        <Wheel
          mustStartSpinning={mustSpin}
          prizeNumber={prizeNumber}
          data={wheelData}
          onStopSpinning={() => {
            setMustSpin(false);
          }}
          backgroundColors={['#ff8f43', '#70bbe0', '#0b3351', '#f9dd50']}
          textColors={['#ffffff']}
          outerBorderColor={'#eeeeee'}
          outerBorderWidth={5}
          innerBorderColor={'#30261a'}
          innerBorderWidth={10}
          radiusLineColor={'#eeeeee'}
          radiusLineWidth={2}
          fontSize={14}
          perpendicularText={true}
          textDistance={60}
          spinDuration={0.4}
        />
      )}
      <button onClick={handleSpinClick} disabled={mustSpin} className="spin-button">
        SPIN
      </button>
    </div>
  );
};

export default WheelMode;
